import { tv } from 'tailwind-variants';

export const buttonVariants = tv({
  base: 'flex duration-200 items-center justify-center cursor-pointer whitespace-nowrap rounded-md text-sm font-medium focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:opacity-50 disabled:cursor-not-allowed',
  variants: {
    variant: {
      default:
        'bg-brand-600 dark:bg-brand-400 font-semibold hover:bg-brand-700 dark:hover:bg-brand-500 text-white hover:shadow-lg',
      secondary: 'text-gray-500 font-semibold border border-gray-300 hover:bg-gray-50 hover:shadow-lg',
      tertiary: 'bg-gray-50 text-gray-700 font-semibold hover:bg-gray-100 hover:shadow-lg',
      destructive: 'bg-destructive text-destructive-foreground hover:bg-destructive/80 hover:shadow-lg',
      link: 'text-blue-600 underline-offset-4 hover:text-blue-700',
      outline: 'border border-brand-700 text-brand-700 font-semibold hover:bg-brand-50 hover:shadow-lg',
      ghost: 'text-brand-700 font-semibold hover:text-brand-800',
      success: 'text-emerald-700 border border-emerald-700 hover:border-emerald-800',
      bagde: 'text-gray-700 font-semibold font-medium text-xs border border-gray-300 rounded-lg px-2 py-1',
    },
    size: {
      default: 'h-10 px-4 py-2',
      sm: 'h-9 rounded-md px-3 text-sm',
      md: 'h-10 px-4 py-2',
      badge: 'h-6 px-2 py-1',
    },
    // New icon-only variant
    iconOnly: {
      true: 'p-0',
    },
  },
  compoundVariants: [
    // Compound variants for icon-only buttons with different sizes
    {
      iconOnly: true,
      size: 'default',
      class: 'w-10 h-10',
    },
    {
      iconOnly: true,
      size: 'sm',
      class: 'w-9 h-9',
    },
    {
      iconOnly: true,
      size: 'md',
      class: 'w-10 h-10',
    },
  ],
  defaultVariants: {
    variant: 'default',
    size: 'default',
    iconOnly: false,
  },
});
